module.exports = __webpack_public_path__ + "img/ucf1g-01.prt.790e5250.jpg";